export default __webpack_public_path__ + "static/media/gptw-logo-icon.f3f81b95.svg";